import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBhE_hdSZP_Hv5OsznNukArYPXmMIHIdjo",
  authDomain: "marie-books.firebaseapp.com",
  databaseURL: "https://marie-books.firebaseio.com",
  projectId: "marie-books",
  storageBucket: "marie-books.appspot.com",
  messagingSenderId: "232909189865",
  appId: "1:232909189865:web:54084ddafb4d03ac42b678",
  measurementId: "G-TCK5LP00MB",
};
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const database = firebase.firestore();
export const analytics = firebase.analytics();
